import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export const login = (username, password) =>
  axios.post(`${API_URL}/api/auth/local`, {
    identifier: username,
    password,
  })
